/**
 * GENERATED by script/gen-sprites.mjs. DO NOT EDIT.
 *
 * ⚠ ADMIN ONLY. Every sprite in one map, keyed `pack/id`.
 *
 * The storefront must NOT import this: it reaches sprites through loadPack() so
 * Rollup emits one chunk per pack and a snow campaign never downloads the
 * Halloween set. The admin has the opposite need — the picker renders tiles from
 * every pack at once — and pays for it in a lazy page chunk instead of a
 * shopper's critical path.
 */
import type { SpriteDef } from '@/shared/engine/types';

export const SPRITE_DEFS: Record<string, SpriteDef> = {
  "core/dot.sm": {
    "d": "M50 40a10 10 0 1 0 0.01 0Z",
    "aspect": 1
  },
  "core/dot.md": {
    "d": "M50 34a16 16 0 1 0 0.01 0Z",
    "aspect": 1
  },
  "core/dot.lg": {
    "d": "M50 26a24 24 0 1 0 0.01 0Z",
    "aspect": 1
  },
  "core/drop.rain": {
    "d": "M50 33C55 48.3 55 62.9 50 67C45 62.9 45 48.3 50 33Z",
    "aspect": 1
  },
  "core/drop.wide": {
    "d": "M50 36C61 48.6 61 60.6 50 64C39 60.6 39 48.6 50 36Z",
    "aspect": 1
  },
  "core/confetto.a": {
    "d": "M38 42h24a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-24a4 4 0 0 1 -4 -4v-8a4 4 0 0 1 4 -4Z",
    "aspect": 1
  },
  "core/confetto.b": {
    "d": "M43 38h14a5 5 0 0 1 5 5v14a5 5 0 0 1 -5 5h-14a5 5 0 0 1 -5 -5v-14a5 5 0 0 1 5 -5Z",
    "aspect": 1
  },
  "core/confetto.long": {
    "d": "M33 44h34a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-34a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3Z",
    "aspect": 1
  },
  "core/star.5": {
    "d": "M50 12L56 43.9L50 49.3L44 43.9Z",
    "aspect": 1,
    "repeat": 5
  },
  "core/star.6": {
    "d": "M50 14L55 44.2L50 48.7L45 44.2Z",
    "aspect": 1,
    "repeat": 6
  },
  "core/star.4": {
    "d": "M50 10L55 43.6L50 48.1L45 43.6Z",
    "aspect": 1,
    "repeat": 4
  },
  "core/sparkle.4": {
    "d": "M50 16L54 46L84 50L54 54L50 84L46 54L16 50L46 46Z",
    "aspect": 1
  },
  "core/sparkle.slim": {
    "d": "M50 10L53 47L90 50L53 53L50 90L47 53L10 50L47 47Z",
    "aspect": 1
  },
  "core/ring.thin": {
    "d": "M50 24a26 26 0 1 0 0.01 0ZM50 28a22 22 0 1 0 0.01 0Z",
    "aspect": 1,
    "rule": "evenodd"
  },
  "core/triangle": {
    "d": "M50 20L78 74H22Z",
    "aspect": 1
  },
  "core/diamond": {
    "d": "M50 16L80 50L50 84L20 50Z",
    "aspect": 1
  },
  "core/bubble": {
    "d": "M50 23a27 27 0 1 0 0.01 0ZM50 28a22 22 0 1 0 0.01 0Z",
    "aspect": 1,
    "rule": "evenodd"
  },
  "winter/flake.6": {
    "d": "M48.4 50L48.4 10L51.6 10L51.6 50ZM50 33.2L41 42.4L42.2 43.6L50 34.8L57.9 43.6L59 42.4ZM50 22.8L43 29.5L44.2 30.7L50 24.4L55.9 30.7L57 29.5Z",
    "aspect": 1,
    "repeat": 6
  },
  "winter/flake.6.fine": {
    "d": "M48.8 50L48.8 14L51.2 14L51.2 50ZM50 32L43 39.6L44.2 40.7L50 33.6L55.9 40.7L57 39.6Z",
    "aspect": 1,
    "repeat": 6
  },
  "winter/flake.6.bold": {
    "d": "M47.6 50L47.6 8L52.4 8L52.4 50ZM50 35.3L38 46.2L39.2 47.4L50 36.9L60.9 47.4L62 46.2ZM50 24L41 32.4L42.2 33.5L50 25.6L57.9 33.5L59 32.4ZM50 14.3L45 18.9L46.2 20.1L50 15.9L53.9 20.1L55 18.9Z",
    "aspect": 1,
    "repeat": 6
  },
  "winter/flake.8": {
    "d": "M48.7 50L48.7 12L51.3 12L51.3 50ZM50 29.1L44 35.4L45.2 36.6L50 30.7L54.9 36.6L56 35.4Z",
    "aspect": 1,
    "repeat": 8
  },
  "winter/flake.star": {
    "d": "M50 10L54 43.6L50 47.2L46 43.6Z",
    "aspect": 1,
    "repeat": 6
  },
  "winter/snowball": {
    "d": "M50 28a22 22 0 1 0 0.01 0Z",
    "aspect": 1
  },
  "winter/icicle": {
    "d": "M42 14h16l-3 30-5 42-5-42Z",
    "aspect": 1
  },
  "winter/mitten": {
    "d": "M38 16h26a12 12 0 0 1 12 12v50a10 10 0 0 1-10 10H40a10 10 0 0 1-10-10V54l-8-6a11 11 0 0 1 8-19l6 1V28a12 12 0 0 1 2-12ZM28 84h48v8H28Z",
    "aspect": 1
  },
  "winter/bauble": {
    "d": "M50 32a26 26 0 1 0 0.01 0ZM44 26h12v10H44Z",
    "aspect": 1
  },
  "winter/candycane": {
    "d": "M40 88V44a14 14 0 0 1 28 0v6h-12v-6a2 2 0 0 0-4 0v44Z",
    "aspect": 1
  },
  "winter/gift": {
    "d": "M18 44h64v38a4 4 0 0 1-4 4H22a4 4 0 0 1-4-4Zm26 0h12v42H44ZM16 30h68v12H16Zm28 0h12v12H44Z",
    "aspect": 1,
    "rule": "evenodd"
  },
  "winter/tree": {
    "d": "M50 10L68 40H58L74 66H26L42 40H32ZM44 66h12v20H44Z",
    "aspect": 1
  },
  "winter/holly": {
    "d": "M50 8c6 8 4 14 10 14 4 0 6-4 10-6-2 6-6 8-4 12 2 4 8 2 12 2-4 4-10 4-10 8s6 6 10 8c-6 2-10 0-12 4s2 8 4 12c-6-2-8-6-12-6-6 0-4 8-8 16-4-8-2-16-8-16-4 0-6 4-12 6 2-4 6-8 4-12s-6-2-12-4c4-2 10-4 10-8s-6-4-10-8c4 0 10 2 12-2 2-4-2-6-4-12 4 2 6 6 10 6 6 0 4-6 10-14Z",
    "aspect": 1
  },
  "winter/bell": {
    "d": "M50 16a6 6 0 0 1 6 6v2c10 4 16 14 16 26v14l6 8H22l6-8V50c0-12 6-22 16-26v-2a6 6 0 0 1 6-6ZM42 76h16a8 8 0 0 1-16 0Z",
    "aspect": 1
  },
  "autumn/leaf.a": {
    "d": "M50 14C72 30 76 56 52 86C50 66 44 60 30 52C34 34 40 22 50 14Z",
    "aspect": 1
  },
  "autumn/leaf.b": {
    "d": "M50 14L58 30L70 24L66 40L82 44L68 54L78 68L60 64L56 86L50 70L44 86L40 64L22 68L32 54L18 44L34 40L30 24L42 30Z",
    "aspect": 1
  },
  "autumn/leaf.oak": {
    "d": "M50 10c6 4 8 10 8 14 5-3 11-2 13 3 4-2 9 1 9 6 0 4-3 7-7 8 4 3 5 8 2 12-2 3-6 4-10 3 2 5-1 10-6 11-4 1-7-1-9-4v27h-4V63c-2 3-5 5-9 4-5-1-8-6-6-11-4 1-8 0-10-3-3-4-2-9 2-12-4-1-7-4-7-8 0-5 5-8 9-6 2-5 8-6 13-3 0-4 2-10 8-14Z",
    "aspect": 1
  },
  "autumn/acorn": {
    "d": "M50 88c-12 0-20-10-20-22 0-8 6-16 20-16s20 8 20 16c0 12-8 22-20 22ZM28 40h44a6 6 0 0 1 0 12H28a6 6 0 0 1 0-12Z",
    "aspect": 1
  },
  "autumn/pinecone": {
    "d": "M50 12c10 8 16 22 16 38 0 20-8 38-16 38s-16-18-16-38c0-16 6-30 16-38Z",
    "aspect": 1
  },
  "autumn/wheat": {
    "d": "M48.3 30L48.3 92L51.8 92L51.8 30ZM50 8c7 7 7 17 0 24-7-7-7-17 0-24ZM44 26c-9-2-17 4-19 14 11 2 19-4 19-14ZM56 26c9-2 17 4 19 14-11 2-19-4-19-14ZM44 44c-9-2-17 4-19 14 11 2 19-4 19-14ZM56 44c9-2 17 4 19 14-11 2-19-4-19-14Z",
    "aspect": 1
  },
  "autumn/mushroom": {
    "d": "M50 18c18 0 30 12 30 24H20c0-12 12-24 30-24ZM42 44h16v40a8 8 0 0 1-16 0Z",
    "aspect": 1
  },
  "autumn/feather": {
    "d": "M54.5 15.7L40.5 91.7L43.5 92.3L57.5 16.3ZM55 20c12 0 20 8 22 20-12 2-21-6-22-20ZM51 40c12 0 20 8 22 20-12 2-21-6-22-20ZM47 60c11 0 18 7 20 18-11 2-19-5-20-18ZM53 22c-12 2-18 11-18 23 11-3 18-11 18-23ZM49 44c-12 2-18 11-18 23 11-3 18-11 18-23Z",
    "aspect": 1
  },
  "spring/petal.a": {
    "d": "M50 37C64 48.7 64 59.9 50 63C36 59.9 36 48.7 50 37Z",
    "aspect": 1
  },
  "spring/petal.cherry": {
    "d": "M50 22c8 6 12 14 12 22 0 10-6 18-12 22-6-4-12-12-12-22 0-8 4-16 12-22Z",
    "aspect": 1
  },
  "spring/blossom.5": {
    "d": "M50 50C39 34.7 39 20.1 50 16C61 20.1 61 34.7 50 50Z",
    "aspect": 1,
    "repeat": 5
  },
  "spring/blossom.6": {
    "d": "M50 50C37 36.5 37 23.6 50 20C63 23.6 63 36.5 50 50Z",
    "aspect": 1,
    "repeat": 6
  },
  "spring/daisy.8": {
    "d": "M50 50C43 33.8 43 18.3 50 14C57 18.3 57 33.8 50 50Z",
    "aspect": 1,
    "repeat": 8
  },
  "spring/heart.a": {
    "d": "M50 82C22 62 16 44 22 33C28 22 44 22 50 34C56 22 72 22 78 33C84 44 78 62 50 82Z",
    "aspect": 1
  },
  "spring/butterfly": {
    "d": "M50 34c8-14 22-18 28-10s-2 20-14 24c12 2 18 12 12 20s-20 2-26-10c-6 12-20 18-26 10s0-18 12-20c-12-4-20-16-14-24s20-4 28 10Z",
    "aspect": 1
  },
  "spring/clover": {
    "d": "M50 46c-6-12-20-12-24-2-3 8 4 16 20 16 0 0 6-6 4-14ZM50 46c6-12 20-12 24-2 3 8-4 16-20 16 0 0-6-6-4-14ZM46 58c-10 8-10 22 0 26 8 3 16-4 16-20 0 0-8-8-16-6ZM48 58L48 90L52 90L52 58Z",
    "aspect": 1
  },
  "spring/egg": {
    "d": "M50 14c14 0 24 22 24 40 0 20-11 32-24 32s-24-12-24-32c0-18 10-40 24-40Z",
    "aspect": 1
  },
  "spring/tulip": {
    "d": "M28 24c0 20 8 34 22 34s22-14 22-34c-6 6-10 10-14 10-3 0-5-4-8-12-3 8-5 12-8 12-4 0-8-4-14-10ZM48 56L48 92L52 92L52 56ZM34 72c-9-1-15 4-16 12 10 2 17-3 16-12Z",
    "aspect": 1
  },
  "spring/raindrop": {
    "d": "M50 35C62 48.5 62 61.4 50 65C38 61.4 38 48.5 50 35Z",
    "aspect": 1
  },
  "celebration/coin.a": {
    "d": "M50 24a26 26 0 1 0 0.01 0ZM50 32a18 18 0 1 0 0.01 0Z",
    "aspect": 1,
    "rule": "evenodd"
  },
  "celebration/coin.stack": {
    "d": "M50 25a24 9 0 1 0 0.01 0ZM50 41a24 9 0 1 0 0.01 0ZM50 57a24 9 0 1 0 0.01 0Z",
    "aspect": 1
  },
  "celebration/streamer": {
    "d": "M26 22c12 8 12 20 0 28s-12 20 0 28c8 6 16 6 24 2-10-2-16-8-16-16 0-12 12-16 12-28S34 22 26 22Z",
    "aspect": 1
  },
  "celebration/balloon": {
    "d": "M50 10a24 30 0 1 0 0.01 0ZM46 70h8l4 22h-16Z",
    "aspect": 1
  },
  "celebration/partyhat": {
    "d": "M50 10 74 78H26ZM22 78h56v10H22Z",
    "aspect": 1
  },
  "celebration/firework": {
    "d": "M50 8L53 43.3L50 46L47 43.3Z",
    "aspect": 1,
    "repeat": 12
  },
  "celebration/ribbon": {
    "d": "M50 42 26 18v20l14 10-14 10v20ZM50 42l24-24v20L60 48l14 10v20Z",
    "aspect": 1
  },
  "celebration/cupcake": {
    "d": "M30 44h40l-6 40a6 6 0 0 1-6 4H42a6 6 0 0 1-6-4ZM50 12c10 0 16 6 16 14 6 0 10 6 10 12H24c0-6 4-12 10-12 0-8 6-14 16-14Z",
    "aspect": 1
  },
  "celebration/champagne": {
    "d": "M32 14h36l-4 26a14 14 0 0 1-12 12v22h10v6H38v-6h10V52a14 14 0 0 1-12-12Z",
    "aspect": 1
  },
  "celebration/trophy": {
    "d": "M32 14h36v20a18 18 0 0 1-14 18v14h10v8H36v-8h10V52a18 18 0 0 1-14-18ZM22 20h8v10a10 10 0 0 1-8-10Zm48 0h8a10 10 0 0 1-8 10Z",
    "aspect": 1
  },
  "celebration/lantern": {
    "d": "M30 32h40v36a20 20 0 0 1-40 0ZM44 20h12v12H44Zm4 60h4v12h-4Z",
    "aspect": 1
  },
  "celebration/tag": {
    "d": "M18 34h40l26 26-40 30-26-26ZM32 46a6 6 0 1 0 0.01 0Z",
    "aspect": 1,
    "rule": "evenodd"
  },
  "spooky/ghost": {
    "d": "M50 10c18 0 30 14 30 32v46l-10-8-10 8-10-8-10 8-10-8-10 8V42c0-18 12-32 30-32ZM40 38a5 6 0 1 0 0.01 0Zm20 0a5 6 0 1 0 0.01 0Z",
    "aspect": 1,
    "rule": "evenodd"
  },
  "spooky/bat": {
    "d": "M50 34c4-8 10-12 14-8 2-6 8-8 12-4 2-4 8-4 10 2-8 2-10 8-10 14 8 0 12 4 14 10-10-2-18 2-24 10-4 6-10 10-16 10s-12-4-16-10c-6-8-14-12-24-10 2-6 6-10 14-10 0-6-2-12-10-14 2-6 8-6 10-2 4-4 10-2 12 4 4-4 10 0 14 8Z",
    "aspect": 1
  },
  "spooky/pumpkin": {
    "d": "M50 26c17 0 30 14 30 31S67 88 50 88 20 74 20 57s13-31 30-31ZM46 12h8v16h-8ZM38 48l8 7-8 7Zm24 0v14l-8-7ZM40 70h20c-3 5-6 8-10 8s-7-3-10-8Z",
    "aspect": 1,
    "rule": "evenodd"
  },
  "spooky/spider": {
    "d": "M50 44a17 14 0 1 0 0.01 0ZM50 27a9 9 0 1 0 0.01 0ZM62.6 58.2L87.1 67.1L88.1 64.3L63.7 55.4ZM54.5 65.3L65.5 88.9L68.2 87.6L57.3 64.1ZM43.8 64.6L34.9 89.1L37.7 90.1L46.6 65.7ZM36.7 56.5L13.1 67.5L14.4 70.2L37.9 59.3ZM37.4 45.8L12.9 36.9L11.9 39.7L36.3 48.6ZM45.5 38.7L34.5 15.1L31.8 16.4L42.7 39.9ZM56.2 39.4L65.1 14.9L62.3 13.9L53.4 38.3ZM63.3 47.5L86.9 36.5L85.6 33.8L62.1 44.7Z",
    "aspect": 1
  },
  "spooky/web": {
    "d": "M50 51.2L92 51.2L92 48.8L50 48.8ZM49.2 50.8L78.8 80.5L80.5 78.8L50.8 49.2ZM48.8 50L48.8 92L51.2 92L51.2 50ZM49.2 49.2L19.5 78.8L21.2 80.5L50.8 50.8ZM50 48.8L8 48.8L8 51.2L50 51.2ZM50.8 49.2L21.2 19.5L19.5 21.2L49.2 50.8ZM51.2 50L51.2 8L48.8 8L48.8 50ZM50.8 50.8L80.5 21.2L78.8 19.5L49.2 49.2ZM65.1 49.6L60.4 60.9L62.2 61.7L66.9 50.4ZM60.9 60.4L49.6 65.1L50.4 66.9L61.7 62.2ZM50.4 65.1L39.1 60.4L38.3 62.2L49.6 66.9ZM39.6 60.9L34.9 49.6L33.1 50.4L37.8 61.7ZM34.9 50.4L39.6 39.1L37.8 38.3L33.1 49.6ZM39.1 39.6L50.4 34.9L49.6 33.1L38.3 37.8ZM49.6 34.9L60.9 39.6L61.7 37.8L50.4 33.1ZM60.4 39.1L65.1 50.4L66.9 49.6L62.2 38.3ZM77.1 49.6L68.9 69.4L70.7 70.2L78.9 50.4ZM69.4 68.9L49.6 77.1L50.4 78.9L70.2 70.7ZM50.4 77.1L30.6 68.9L29.8 70.7L49.6 78.9ZM31.1 69.4L22.9 49.6L21.1 50.4L29.3 70.2ZM22.9 50.4L31.1 30.6L29.3 29.8L21.1 49.6ZM30.6 31.1L50.4 22.9L49.6 21.1L29.8 29.3ZM49.6 22.9L69.4 31.1L70.2 29.3L50.4 21.1ZM68.9 30.6L77.1 50.4L78.9 49.6L70.7 29.8ZM89.1 49.6L77.4 77.9L79.2 78.7L90.9 50.4ZM77.9 77.4L49.6 89.1L50.4 90.9L78.7 79.2ZM50.4 89.1L22.1 77.4L21.3 79.2L49.6 90.9ZM22.6 77.9L10.9 49.6L9.1 50.4L20.8 78.7ZM10.9 50.4L22.6 22.1L20.8 21.3L9.1 49.6ZM22.1 22.6L50.4 10.9L49.6 9.1L21.3 20.8ZM49.6 10.9L77.9 22.6L78.7 20.8L50.4 9.1ZM77.4 22.1L89.1 50.4L90.9 49.6L79.2 21.3Z",
    "aspect": 1
  },
  "spooky/skull": {
    "d": "M50 12c20 0 32 14 32 32 0 12-6 20-10 24v14a4 4 0 0 1-4 4H32a4 4 0 0 1-4-4V68c-4-4-10-12-10-24 0-18 12-32 32-32ZM36 40a8 9 0 1 0 0.01 0Zm28 0a8 9 0 1 0 0.01 0Z",
    "aspect": 1,
    "rule": "evenodd"
  },
  "spooky/cat": {
    "d": "M26 34 20 14l18 10c8-3 16-3 24 0l18-10-6 20c6 8 8 18 8 26 0 18-14 28-32 28S18 78 18 60c0-8 2-18 8-26Zm12 26a5 6 0 1 0 0.01 0Zm24 0a5 6 0 1 0 0.01 0Z",
    "aspect": 1,
    "rule": "evenodd"
  },
  "spooky/moon.crescent": {
    "d": "M62 12a40 40 0 1 0 0 76 32 32 0 0 1 0-76Z",
    "aspect": 1
  },
  "spooky/candy": {
    "d": "M50 33a19 17 0 1 0 0.01 0ZM32 40 12 26v48l20-14Zm36 0 20-14v48L68 60Z",
    "aspect": 1
  },
  "spooky/potion": {
    "d": "M40 12h20v14l16 34a20 20 0 0 1-18 30H42a20 20 0 0 1-18-30l16-34Z",
    "aspect": 1
  },
  "romance/heart.solid": {
    "d": "M50 82C22 62 16 44 22 33C28 22 44 22 50 34C56 22 72 22 78 33C84 44 78 62 50 82Z",
    "aspect": 1
  },
  "romance/heart.outline": {
    "d": "M50 82C22 62 16 44 22 33C28 22 44 22 50 34C56 22 72 22 78 33C84 44 78 62 50 82ZM50 72C28 56 24 42 28 34C32 26 44 28 50 38C56 28 68 26 72 34C76 42 72 56 50 72Z",
    "aspect": 1,
    "rule": "evenodd"
  },
  "romance/heart.small": {
    "d": "M50 74C30 58 26 44 30 36C34 28 44 30 50 40C56 30 66 28 70 36C74 44 70 58 50 74Z",
    "aspect": 1
  },
  "romance/rose": {
    "d": "M50 14c15 0 26 11 26 25S65 66 50 66 24 53 24 39 35 14 50 14ZM50 24c-9 0-16 7-16 15 0 7 5 12 12 12 5 0 9-4 9-8 0-3-2-5-5-5-2 0-3 1-3 3 0-4 3-7 7-7 5 0 9 4 9 10 0 8-7 14-16 14-11 0-19-9-19-20 0-12 10-21 22-21ZM48 62L48 92L52 92L52 62ZM34 74c-9-1-15 4-16 12 10 2 17-3 16-12Z",
    "aspect": 1,
    "rule": "evenodd"
  },
  "romance/kiss": {
    "d": "M50 40c6-10 16-14 24-10 8 4 10 12 6 18-2 3-5 5-8 6 4 2 6 5 6 9 0 10-13 19-28 19S22 73 22 63c0-4 2-7 6-9-3-1-6-3-8-6-4-6-2-14 6-18 8-4 18 0 24 10ZM26 54h48c-6 4-15 6-24 6s-18-2-24-6Z",
    "aspect": 1,
    "rule": "evenodd"
  },
  "romance/envelope": {
    "d": "M14 28h72v44H14ZM20 34h60L50 58Z",
    "aspect": 1,
    "rule": "evenodd"
  },
  "romance/sparkle.heart": {
    "d": "M50 78C32 64 28 52 32 44C36 36 44 38 50 46C56 38 64 36 68 44C72 52 68 64 50 78ZM18 14l3 9 9 3-9 3-3 9-3-9-9-3 9-3Z",
    "aspect": 1
  },
  "summer/sun": {
    "d": "M50 30a20 20 0 1 0 0.01 0Z",
    "aspect": 1
  },
  "summer/sunray": {
    "d": "M50 6L54 43L50 46.6L46 43Z",
    "aspect": 1,
    "repeat": 8
  },
  "summer/shell": {
    "d": "M50 12c20 0 36 16 36 34 0 6-2 12-4 18l-6-4-6 6-6-4-6 6-8-4-8 4-6-6-6 4-6-6-6 4c-2-6-4-12-4-18 0-18 16-34 36-34ZM48.7 22L48.7 74L51.3 74L51.3 22ZM49 23.5L25 65.5L27 66.5L51 24.5ZM49 24.5L73 66.5L75 65.5L51 23.5ZM49 23.8L37 71.8L39 72.2L51 24.2ZM49 24.2L61 72.2L63 71.8L51 23.8Z",
    "aspect": 1,
    "rule": "evenodd"
  },
  "summer/palm": {
    "d": "M48 20L48 92L52 92L52 20ZM50 22c-16 2-26 12-30 26 12-8 22-10 30-8ZM50 22c16 2 26 12 30 26-12-8-22-10-30-8ZM50 44c-13 3-21 11-24 22 10-7 18-9 24-8ZM50 44c13 3 21 11 24 22-10-7-18-9-24-8Z",
    "aspect": 1
  },
  "summer/icecream": {
    "d": "M50 12c14 0 24 10 24 22H26c0-12 10-22 24-22ZM26 38h48L50 90Z",
    "aspect": 1
  },
  "summer/watermelon": {
    "d": "M14 34h72c0 30-16 52-36 52S14 64 14 34Z",
    "aspect": 1
  },
  "summer/beachball": {
    "d": "M50 18a32 32 0 1 0 0.01 0Z",
    "aspect": 1
  },
  "summer/sunglasses": {
    "d": "M8 34h34v14a17 17 0 0 1-34 0ZM58 34h34v14a17 17 0 0 1-34 0ZM42 38h16v6H42Z",
    "aspect": 1
  }
};

export function spriteDefs(pack: string, ids: string[]): SpriteDef[] {
  return ids.map((id) => SPRITE_DEFS[`${pack}/${id}`]).filter(Boolean);
}
